var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { PlanTreatmentsService } from "./plan-treatments.service";
import { DescriptionService } from "../../description/description.service";
import { Observable } from "rxjs";
import { CustomTreatmentService } from "../../custom-treatment/custom-treatment.service";
var PlanDescriptionsService = /** @class */ (function () {
    function PlanDescriptionsService(descriptionsService, treatmentsService, customTreatmentService) {
        this.descriptionsService = descriptionsService;
        this.treatmentsService = treatmentsService;
        this.customTreatmentService = customTreatmentService;
        this.descriptions$ = descriptionsService.getFullDescriptions("plan");
        this.getCustomTreatments();
    }
    PlanDescriptionsService.prototype.getCustomTreatments = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, this.customTreatmentService
                                .getCustomTreatments(true)
                                .toPromise()];
                    case 1:
                        _a.customTreatments = _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    PlanDescriptionsService.prototype.getDescriptions = function (items) {
        var _this = this;
        return this.descriptions$.switchMap(function (descriptions) {
            var addedDescriptions = [];
            var finalDescriptions = [];
            if (items) {
                var _loop_1 = function (item) {
                    if (item.customTreatmentId) {
                        // get custom treatment description only if it is
                        var customTreatmentDescription = _this.customTreatments.filter(function (customTreatment) {
                            return customTreatment.id === item.customTreatmentId &&
                                customTreatment.description !== null &&
                                customTreatment.description.length > 0;
                        });
                        var customDescriptionName = item.name;
                        var customDescriptionContent = customTreatmentDescription.length > 0
                            ? customTreatmentDescription[0].description
                            : descriptions[item.treatment]
                                ? descriptions[item.treatment].content
                                : "";
                        if (!customDescriptionContent) {
                            return "continue";
                        }
                        var customDescription = {
                            name: customDescriptionName,
                            content: customDescriptionContent,
                        };
                        if (addedDescriptions.includes(item.customTreatmentId)) {
                            return "continue";
                        }
                        addedDescriptions.push(item.customTreatmentId);
                        finalDescriptions.push(customDescription);
                        return "continue";
                    }
                    var conditionClass = _this.treatmentsService.getClassForTreatment(item.treatment);
                    var descriptionsIdentifiers = conditionClass.getDescriptionIdentifiers(item);
                    for (var _i = 0, descriptionsIdentifiers_1 = descriptionsIdentifiers; _i < descriptionsIdentifiers_1.length; _i++) {
                        var identifier = descriptionsIdentifiers_1[_i];
                        if (!addedDescriptions.includes(identifier)) {
                            addedDescriptions.push(identifier);
                            if (descriptions[identifier]) {
                                finalDescriptions.push(descriptions[identifier]);
                            }
                        }
                    }
                };
                for (var _i = 0, items_1 = items; _i < items_1.length; _i++) {
                    var item = items_1[_i];
                    _loop_1(item);
                }
            }
            return Observable.of(finalDescriptions);
        });
    };
    return PlanDescriptionsService;
}());
export { PlanDescriptionsService };



// WEBPACK FOOTER //
// /app/src/app/core/store/plan-editor/plan/plan-descriptions.service.ts.pre-build-optimizer.js